import {Injectable} from '@angular/core';
import {Router, UrlTree} from '@angular/router';
import {EnvironmentService} from '@app/modules/common/services/environment-service';
import {UserAuthorisationService} from '@app/modules/common/services/user-authorisation.service';

/** The Inbox is off unless the tenant enables `claimManagementFeatures.inbox`, and is limited to authorisation capturers and admins. */
@Injectable({
  providedIn: 'root'
})
export class InboxFeatureGuard {
  constructor(
    private router: Router,
    private environmentService: EnvironmentService,
    private userAuthorisationService: UserAuthorisationService) {
  }

  canActivate(): boolean | UrlTree {
    const allowed = this.environmentService.isInboxFeatureEnabled() &&
      (this.userAuthorisationService.hasRoleToSubmitAndReviewTransactions() || this.userAuthorisationService.hasRoleAdmin());
    return allowed || this.router.parseUrl('/home');
  }
}
